import { Checkbox } from "@merge-api/merge-javascript-shared";

interface CMDCheckboxLabelProps {
  label: string;
  checked: boolean;
  onChange: (value: boolean) => void;
}

const CMDCheckboxLabel = ({ label, checked, onChange }: CMDCheckboxLabelProps) => {
  return <Checkbox label={label} checked={checked} onChange={() => onChange(!checked)} />;
};

export default CMDCheckboxLabel;
